import React from "react";
import "./ChartNavigationBar.css";
import { Link } from "react-router-dom";

function scrollToChart() {
  // Defer so the destination chart can mount after route change
  window.setTimeout(() => {
    const el = document.getElementById("chart");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, 100);
}

function ChartNavigationBar({ buttonsList }) {
  function setChartType(button) {
    if (button?.chartType) {
      localStorage.setItem("chartType", button.chartType);
    }
  }

  function handleChartClick(button) {
    setChartType(button);
    scrollToChart();
  }

  return (
    <div className="chartnavigationbar-wrapper">
      <div className="chartnavigationbar-container">
        {buttonsList &&
          buttonsList.map((button) =>
            button.chartType === "stats" ? (
              <div key={button.title} className="chartnavigationbar-button">
                <img
                  className="chartnavigationbar-button-icon"
                  src={`/Assets/DataCentre/icons/${button.icon.toLowerCase()}.png`}
                  alt={`${button.title} icon`}
                />
                <div className="chartnavigationbar-button-title">
                  {button.title}
                </div>
                <div>[Statistic]</div>
              </div>
            ) : button.chartType === "link" ? (
              <a
                key={button.title}
                href={`/${button.linkTo}`.replace(/\/+/g, "/")}
                onClick={() => setChartType(button)}
                className="chartnavigationbar-button"
              >
                <img
                  className="chartnavigationbar-button-icon"
                  src={`/Assets/DataCentre/icons/${button.icon.toLowerCase()}.png`}
                  alt={`${button.title} icon`}
                />
                <div className="chartnavigationbar-button-title">
                  {button.title}
                </div>
              </a>
            ) : (
              <Link
                key={button.title}
                to={`/data/${button.categoryID}/${button.chartID}#chart`}
                onClick={() => handleChartClick(button)}
                className="chartnavigationbar-button"
              >
                <img
                  className="chartnavigationbar-button-icon"
                  src={`/Assets/DataCentre/icons/${button.icon.toLowerCase()}.png`}
                  alt={`${button.title} icon`}
                />
                <div className="chartnavigationbar-button-title">
                  {button.title}
                </div>
              </Link>
            )
          )}
      </div>
    </div>
  );
}

export default ChartNavigationBar;
